import Splide from '@splidejs/splide';

function initProductTabs() {
  var tabsRoot = document.querySelector('[data-product-tabs]');

  if (!tabsRoot) {
    return;
  }

  var tabs = Array.from(tabsRoot.querySelectorAll('[role="tab"]'));
  var panels = Array.from(tabsRoot.querySelectorAll('[role="tabpanel"]'));

  function activateTab(activeTab, moveFocus) {
    tabs.forEach(function (tab) {
      var isActive = tab === activeTab;
      var panelId = tab.getAttribute('aria-controls');
      var panel = panels.find(function (item) { return item.id === panelId; });

      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');

      if (panel) {
        panel.hidden = !isActive;
      }
    });

    if (moveFocus) {
      activeTab.focus();
    }
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () {
      activateTab(tab, false);
    });

    tab.addEventListener('keydown', function (event) {
      var nextIndex = index;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    });
  });
}

function initProductVariations() {
  var form = document.querySelector('.variations_form');
  var price = document.querySelector('[data-product-price]');
  var mainImage = document.querySelector('[data-product-gallery-image]');
  var mainSlide = mainImage ? mainImage.closest('.splide__slide') : null;
  var lightboxImage = document.querySelector('[data-product-lightbox-image]');
  var purchaseButtons = Array.from(form ? form.querySelectorAll('.single_add_to_cart_button') : []);

  if (!form || !window.jQuery) {
    return;
  }

  var initialPrice = price ? price.innerHTML : '';
  var initialImage = mainImage ? mainImage.getAttribute('src') : '';
  var initialAlt = mainImage ? mainImage.getAttribute('alt') : '';
  var initialFull = mainSlide ? mainSlide.getAttribute('data-image-full') : '';

  function updateImage(image) {
    if (!mainImage || !image || !image.src) {
      return;
    }

    mainImage.setAttribute('src', image.src);
    mainImage.setAttribute('srcset', image.srcset || '');
    mainImage.setAttribute('sizes', image.sizes || '');
    mainImage.setAttribute('alt', image.alt || initialAlt);

    if (mainSlide) {
      mainSlide.setAttribute('data-image-full', image.full_src || image.src);
      mainSlide.setAttribute('data-image-alt', image.alt || initialAlt);
    }

    if (lightboxImage) {
      lightboxImage.setAttribute('src', image.full_src || image.src);
      lightboxImage.setAttribute('alt', image.alt || initialAlt);
    }
  }

  function resetProductPresentation() {
    if (price) {
      price.innerHTML = initialPrice;
    }

    if (mainImage) {
      mainImage.setAttribute('src', initialImage);
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.setAttribute('alt', initialAlt);
    }

    if (mainSlide) {
      mainSlide.setAttribute('data-image-full', initialFull);
      mainSlide.setAttribute('data-image-alt', initialAlt);
    }

    if (lightboxImage) {
      lightboxImage.setAttribute('src', initialFull || initialImage);
      lightboxImage.setAttribute('alt', initialAlt);
    }

    purchaseButtons.forEach(function (button) {
      button.setAttribute('aria-disabled', 'true');
    });
  }

  window.jQuery(form).on('found_variation', function (event, variation) {
    if (price && (variation.crispins_price_html || variation.price_html)) {
      // HTML comes from the theme/WooCommerce; preserve the price component.
      price.innerHTML = variation.crispins_price_html || variation.price_html;
    }

    updateImage(variation.image);

    purchaseButtons.forEach(function (button) {
      button.setAttribute('aria-disabled', variation.is_purchasable ? 'false' : 'true');
    });
  });

  window.jQuery(form).on('hide_variation reset_data', resetProductPresentation);
}

export default function initProductDetail() {
  initProductTabs();
  initProductVariations();

  var gallery = document.querySelector('.js-product-gallery');
  var thumbs = document.querySelectorAll('[data-product-thumb]');
  var lightbox = document.querySelector('[data-product-lightbox]');
  var lightboxImage = document.querySelector('[data-product-lightbox-image]');
  var lightboxOpen = document.querySelectorAll('[data-product-lightbox-open]');
  var lightboxClose = document.querySelectorAll('[data-product-lightbox-close]');

  if (!gallery) {
    return;
  }

  var slider = new Splide(gallery, {
    type: 'slide',
    speed: 650,
    rewind: true,
    rewindSpeed: 650,
    arrows: false,
    pagination: false,
    drag: true,
    keyboard: 'focused',
    reducedMotion: { speed: 0, rewindSpeed: 0 },
  });

  function updateGallery(index) {
    var slide = gallery.querySelectorAll('.splide__slide')[index];
    var image = slide ? slide.querySelector('img') : null;
    var track = gallery.querySelector('.splide__track');

    thumbs.forEach(function (item, itemIndex) {
      var active = itemIndex === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (slide && lightboxImage) {
      lightboxImage.setAttribute('src', slide.getAttribute('data-image-full') || (image ? image.src : ''));
      lightboxImage.setAttribute('alt', slide.getAttribute('data-image-alt') || '');
    }

    if (track && image) {
      var resizeTrack = function () {
        track.style.height = image.offsetHeight + 'px';
      };

      if (image.complete) {
        resizeTrack();
      } else {
        image.addEventListener('load', resizeTrack, { once: true });
      }
    }
  }

  slider.on('mounted', function () { updateGallery(slider.index); });
  slider.on('move', function (newIndex) { updateGallery(newIndex); });
  slider.on('resize', function () { updateGallery(slider.index); });
  slider.mount();

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      slider.go(Number(thumb.getAttribute('data-slide-index')) || 0);
    });
  });

  if (lightbox) {
    lightboxOpen.forEach(function (openButton) {
      openButton.addEventListener('click', function () {
        updateGallery(slider.index);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('product-lightbox-open');
      });
    });

    lightboxClose.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('product-lightbox-open');
      });
    });
  }
}
